import { render, staticRenderFns } from "./AssuranceComplaints.vue?vue&type=template&id=3c6fb92e&scoped=true&"
import script from "./AssuranceComplaints.vue?vue&type=script&lang=js&"
export * from "./AssuranceComplaints.vue?vue&type=script&lang=js&"
import style0 from "./AssuranceComplaints.vue?vue&type=style&index=0&id=3c6fb92e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6fb92e",
  null
  
)

export default component.exports